<div class="prepareRecipe">
  <div class="title">New recipe</div>
  <div class="form">
    <div class="wrapper">
      <div class="label">Name</div>
      <div>
        <input type="text" />
      </div>
    </div>
    <div class="wrapper">
      <div class="label">Description</div>
      <div>
        <textarea></textarea>
      </div>
    </div>
    <div class="wrapper">
      <div class="label">Calories</div>
      <div>
        <input type="text" />
      </div>
    </div>
    <div class="wrapper">
      <div class="label">Time</div>
      <div>
        <input type="text" />
      </div>
    </div>
    <div class="wrapper">
      <div class="label">Portion</div>
      <div>
        <input type="text" />
      </div>
    </div>
    <div class="dynamic">
      <div class="wrapper">
        <div class="label">Ingredients</div>
        <div class="multiple">
          <div>
            <div class="label">Name</div>
            <div>
              <input type="text" />
            </div>
          </div>
          <div>
            <div class="label">Quantity</div>
            <div>
              <input type="text" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <button>Add ingredient</button>
      </div>
    </div>
    <div class="dynamic">
      <div class="wrapper">
        <div class="label">Steps</div>
        <div class="step">
          <div class="header">
            <div>Step 1</div>
            <div>
              <input type="text" placeholder="Title" />
            </div>
          </div>
          <div>
            <textarea placeholder="Description"></textarea>
          </div>
        </div>
      </div>
      <div>
        <button>Add step</button>
      </div>
    </div>
  </div>
  <div class="action">
    <button>Post recipe</button>
  </div>
</div>
